import { Navigate, Outlet } from "react-router-dom";

const LoginProtectedRoute = () => {
  const auth = sessionStorage.getItem("token");

  return !auth ? <Outlet /> : <Navigate to="/all-reports" />;
};

export default LoginProtectedRoute;
